import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-spinner',
  standalone: false,
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent {
  /** Diameter in pixels. */
  @Input() size = 50;

  /** Stroke thickness of the spinner ring. */
  @Input() strokeWidth: string | number = 4;

  /** Stroke colour override; defaults to the app theme colour. */
  @Input() color?: string;

  /** Optional caption shown beneath the spinner. */
  @Input() label?: string;

  /** Centre and fill the available space (default). Set false to render inline. */
  @Input() fill = true;

  get dimension(): string {
    return `${this.size}px`;
  }

  /** When a colour is supplied, override PrimeNG's spinner colour CSS vars. */
  get colorVars(): Record<string, string> {
    if (!this.color) {
      return {};
    }
    return {
      '--p-progressspinner-color-1': this.color,
      '--p-progressspinner-color-2': this.color,
      '--p-progressspinner-color-3': this.color,
      '--p-progressspinner-color-4': this.color
    };
  }
}
